<template>
  <div class="py-3">
    <div class="form-section-base__controls">
      <v-row>
        <v-col>
          <v-radio-group v-model="v.role.$model" row>
            <div class="d-flex">
              <v-radio
                class="mb-0"
                label="Физическое лицо"
                :value="Role.PERSON"
              />
              <v-radio
                class="mb-0"
                label="Юридическое лицо"
                :value="Role.ORGANIZATION"
              />
              <v-radio
                class="mb-0"
                label="Иностранное юридическое лицо"
                :value="Role.FOREIGN_ORGANIZATION"
              />
            </div>
          </v-radio-group>
        </v-col>
      </v-row>
    </div>

    <Person v-if="v.role.$model === Role.PERSON" :v="v.person" />

    <Organization
      v-if="v.role.$model === Role.ORGANIZATION"
      :v="v.organization"
    />

    <ForeignOrganization
      v-if="v.role.$model === Role.FOREIGN_ORGANIZATION"
      :v="v.foreignOrganization"
    />

    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="v.details.information.$model"
          :errorMessages="getValidationErrorText(v.details.information)"
          label="Иные сведения о кредиторе"
          outlined
        />
      </v-col>

      <v-col cols="6">
        <CurrencyField
          v-model="v.details.depositAmount.$model"
          label="Размер денежных средств в рублях"
          :errorMessages="getValidationErrorText(v.details.depositAmount)"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.details.placePerformanceObligation.$model"
          :errorMessages="
            getValidationErrorText(v.details.placePerformanceObligation)
          "
          label="Место исполнения обязательства в соответствии с требованиями законодательства Российской Федерации"
          outlined
        />
      </v-col>
    </v-row>

    <v-btn
      v-if="canDelete"
      depressed
      color="primary"
      class="button-base"
      @click="$emit('delete')"
    >
      Удалить
    </v-btn>
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import { maxLength, required } from 'vuelidate/lib/validators';
import CurrencyField from '@/components/base/CurrencyField.vue';

import { Role } from '@/utils/dictionaries';
import {
  CURRENCY_MAX_LENGTH,
  CURRENCY_ONLY_POSITIVE,
  getValidationErrorText,
  EMOJI,
} from '@/utils/validate';
import Person, { personModel, personValidation } from './Person';
import Organization, {
  organizationModel,
  organizationValidation,
} from './Organization';
import ForeignOrganization, {
  foreignOrganizationModel,
  foreignOrganizationValidation,
} from './ForeignOrganization';

export const creditorModel = {
  role: Role.PERSON,
  [Role.PERSON]: cloneDeep(personModel),
  [Role.ORGANIZATION]: cloneDeep(organizationModel),
  [Role.FOREIGN_ORGANIZATION]: cloneDeep(foreignOrganizationModel),
  details: {
    information: '',
    depositAmount: null,
    depositCurrency: 'RUB', // default
    placePerformanceObligation: '',
  },
};

export const creditorValidation = {
  role: {},
  [Role.PERSON]: personValidation,
  [Role.ORGANIZATION]: organizationValidation,
  [Role.FOREIGN_ORGANIZATION]: foreignOrganizationValidation,
  details: {
    information: {
      maxLength: maxLength(4000),
      EMOJI,
    },
    depositAmount: {
      required,
      CURRENCY_MAX_LENGTH,
      CURRENCY_ONLY_POSITIVE,
    },
    depositCurrency: {
      required,
    },
    placePerformanceObligation: {
      required,
      maxLength: maxLength(4000),
      EMOJI,
    },
  },
};

export default {
  name: 'Creditor',
  props: {
    v: {
      required: true,
    },
    canDelete: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Person,
    Organization,
    ForeignOrganization,
    CurrencyField,
  },
  data: () => ({
    Role,
    getValidationErrorText,
    depositAmount2: null,
  }),
};
</script>

<style scoped></style>
